import { ApiClient } from '../../core/api/ApiClient';
import { SettlementRepositoryImpl } from './implementations';
import { SettlementService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class SettlementDomainContainer {
  constructor() {
    this._apiClient = null;
    this._settlementRepository = null;
    this._settlementService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get settlementRepository() {
    if (!this._settlementRepository) {
      this._settlementRepository = new SettlementRepositoryImpl(this.apiClient);
    }
    return this._settlementRepository;
  }

  get settlementService() {
    if (!this._settlementService) {
      this._settlementService = new SettlementService(this.settlementRepository);
    }
    return this._settlementService;
  }

  reset() {
    this._apiClient = null;
    this._settlementRepository = null;
    this._settlementService = null;
  }
}

const container = new SettlementDomainContainer();

export const getSettlementService = () => container.settlementService;
export const getSettlementRepository = () => container.settlementRepository;
export const resetSettlementContainer = () => container.reset();
